// Build CSS
// import '../css/app.css'

// Import JS Modules
import menu_init from './modules/menu'

// Load Menu Script
document.addEventListener('DOMContentLoaded', function ()
{
    changeMenuItem();
    menu_init();
});
changeMenuItem();

function changeMenuItem()
{
    const hash = window.location.hash.substr(1);

    if (hash === 'preise') {
        const menuItems = document.querySelectorAll('.page-item-45');
        menuItems.forEach((menuItem) => {
            menuItem.classList.remove('current-menu-item');
            menuItem.classList.remove('current_page_item');
        });
        document.querySelectorAll('.menu-item-222').forEach((menuItem) => {
            menuItem.classList.add('current_page_item');
        });
    }
}

/* Header/Footer Animation */
window.isElemInViewport = (elm) => {
  const rect = elm.getBoundingClientRect();
  const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);

  return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
}

const headerArrow = document.querySelector('.wp-perf__hero-arrow');
headerArrow.classList.add('animated');
headerArrow.classList.add('fadeInDown');

const scrollListener = () => {
  const header = document.querySelector('.wp-perf__hero');
  const headerArrow = document.querySelector('.wp-perf__hero-arrow');
  
  headerArrow.classList.add('animated');
  headerArrow.classList.add('fadeInDown');
  
  const footer = document.querySelector('.wp-perf__footer');
  const footerArrow = document.querySelector('.wp-perf__footer .arrow__top');

  const footerInViewport = window.isElemInViewport(footer);
  if (footerInViewport){
    footerArrow.classList.add('animated');
    footerArrow.classList.add('fadeInUp');
  }
  else{
    footerArrow.classList.remove('animated');
    footerArrow.classList.remove('fadeInUp');
  }

  const headerInViewport = window.isElemInViewport(header);
  if (headerInViewport){
    headerArrow.classList.add('animated');
    headerArrow.classList.add('fadeInDown');
  }
  else{
    headerArrow.classList.remove('animated');
    headerArrow.classList.remove('fadeInDown');
  }

}

document.addEventListener('scroll', scrollListener, {passive: true});
